// @flow

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../pages/home';
import Layout from '../pages/layout';
import Schedule from '../pages/schedule';
import Search from '../pages/search';
import MyWorks from '../pages/myworks';
import MyWork from '../pages/mywork';
import MemberWorks from '../pages/memberworks';
import MemberWork from '../pages/memberwork';
import Logout from '../pages/logout';
import SearchWorks from '../pages/searchworks';
import SearchWork from '../pages/searchwork';
import PossibleMatches from '../pages/possiblematches';
import PossibleMatch from '../pages/possiblematch';
import AlternativeTitles from '../pages/alternative-titles';

const routes = (
  <Layout>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/schedule" component={Schedule} />
      <Route path="/search" component={Search} />
      <Route path="/myworks" component={MyWorks} />
      <Route path="/mywork" component={MyWork} />
      <Route path="/logout" component={Logout} />
      <Route path="/searchworks" component={SearchWorks} />
      <Route path="/searchwork" component={SearchWork} />
      <Route path="/alternativetitles" component={AlternativeTitles} />
      <Route path="/memberworks" component={MemberWorks} />
      <Route path="/memberwork" component={MemberWork} />
      <Route path="/possiblematches" component={PossibleMatches} />
      <Route path="/possiblematch" component={PossibleMatch} />
    </Switch>
  </Layout>
);

export default routes;
